(function() {
  const curalate = angular.module('curalate');

    // Returned by graph.facebook.com/v3.0/search?type=adgeolocation&location_types=['country']
  const facebookAdCountries = [
    {
      key: 'AF',
      name: 'Afghanistan',
      type: 'country',
      twoDigitCode: 'AF',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'AX',
      name: 'Aland Islands',
      type: 'country',
      twoDigitCode: 'AX',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'AL',
      name: 'Albania',
      type: 'country',
      twoDigitCode: 'AL',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'DZ',
      name: 'Algeria',
      type: 'country',
      twoDigitCode: 'DZ',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'AS',
      name: 'American Samoa',
      type: 'country',
      twoDigitCode: 'AS',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'AD',
      name: 'Andorra',
      type: 'country',
      twoDigitCode: 'AD',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'AO',
      name: 'Angola',
      type: 'country',
      twoDigitCode: 'AO',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'AI',
      name: 'Anguilla',
      type: 'country',
      twoDigitCode: 'AI',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'AQ',
      name: 'Antarctica',
      type: 'country',
      twoDigitCode: 'AQ',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'AG',
      name: 'Antigua',
      type: 'country',
      twoDigitCode: 'AG',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'AR',
      name: 'Argentina',
      type: 'country',
      twoDigitCode: 'AR',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'AM',
      name: 'Armenia',
      type: 'country',
      twoDigitCode: 'AM',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'AW',
      name: 'Aruba',
      type: 'country',
      twoDigitCode: 'AW',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'AU',
      name: 'Australia',
      type: 'country',
      twoDigitCode: 'AU',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'AT',
      name: 'Austria',
      type: 'country',
      twoDigitCode: 'AT',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'AZ',
      name: 'Azerbaijan',
      type: 'country',
      twoDigitCode: 'AZ',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'BH',
      name: 'Bahrain',
      type: 'country',
      twoDigitCode: 'BH',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'BD',
      name: 'Bangladesh',
      type: 'country',
      twoDigitCode: 'BD',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'BB',
      name: 'Barbados',
      type: 'country',
      twoDigitCode: 'BB',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'BY',
      name: 'Belarus',
      type: 'country',
      twoDigitCode: 'BY',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'BE',
      name: 'Belgium',
      type: 'country',
      twoDigitCode: 'BE',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'BZ',
      name: 'Belize',
      type: 'country',
      twoDigitCode: 'BZ',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'BJ',
      name: 'Benin',
      type: 'country',
      twoDigitCode: 'BJ',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'BM',
      name: 'Bermuda',
      type: 'country',
      twoDigitCode: 'BM',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'BT',
      name: 'Bhutan',
      type: 'country',
      twoDigitCode: 'BT',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'BO',
      name: 'Bolivia',
      type: 'country',
      twoDigitCode: 'BO',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'BQ',
      name: 'Bonaire, Sint Eustatius and Saba',
      type: 'country',
      twoDigitCode: 'BQ',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'BA',
      name: 'Bosnia and Herzegovina',
      type: 'country',
      twoDigitCode: 'BA',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'BW',
      name: 'Botswana',
      type: 'country',
      twoDigitCode: 'BW',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'BV',
      name: 'Bouvet Island',
      type: 'country',
      twoDigitCode: 'BV',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'BR',
      name: 'Brazil',
      type: 'country',
      twoDigitCode: 'BR',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'IO',
      name: 'British Indian Ocean Territory',
      type: 'country',
      twoDigitCode: 'IO',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'VG',
      name: 'British Virgin Islands',
      type: 'country',
      twoDigitCode: 'VG',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'BN',
      name: 'Brunei',
      type: 'country',
      twoDigitCode: 'BN',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'BG',
      name: 'Bulgaria',
      type: 'country',
      twoDigitCode: 'BG',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'BF',
      name: 'Burkina Faso',
      type: 'country',
      twoDigitCode: 'BF',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'BI',
      name: 'Burundi',
      type: 'country',
      twoDigitCode: 'BI',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'KH',
      name: 'Cambodia',
      type: 'country',
      twoDigitCode: 'KH',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'CM',
      name: 'Cameroon',
      type: 'country',
      twoDigitCode: 'CM',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'CA',
      name: 'Canada',
      type: 'country',
      twoDigitCode: 'CA',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'CV',
      name: 'Cape Verde',
      type: 'country',
      twoDigitCode: 'CV',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'KY',
      name: 'Cayman Islands',
      type: 'country',
      twoDigitCode: 'KY',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'CF',
      name: 'Central African Republic',
      type: 'country',
      twoDigitCode: 'CF',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'TD',
      name: 'Chad',
      type: 'country',
      twoDigitCode: 'TD',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'CL',
      name: 'Chile',
      type: 'country',
      twoDigitCode: 'CL',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'CN',
      name: 'China',
      type: 'country',
      twoDigitCode: 'CN',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'CX',
      name: 'Christmas Island',
      type: 'country',
      twoDigitCode: 'CX',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'CC',
      name: 'Cocos (Keeling) Islands',
      type: 'country',
      twoDigitCode: 'CC',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'CO',
      name: 'Colombia',
      type: 'country',
      twoDigitCode: 'CO',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'KM',
      name: 'Comoros',
      type: 'country',
      twoDigitCode: 'KM',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'CK',
      name: 'Cook Islands',
      type: 'country',
      twoDigitCode: 'CK',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'CR',
      name: 'Costa Rica',
      type: 'country',
      twoDigitCode: 'CR',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'HR',
      name: 'Croatia',
      type: 'country',
      twoDigitCode: 'HR',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'CW',
      name: 'Curaçao',
      type: 'country',
      twoDigitCode: 'CW',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'CY',
      name: 'Cyprus',
      type: 'country',
      twoDigitCode: 'CY',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'CZ',
      name: 'Czech Republic',
      type: 'country',
      twoDigitCode: 'CZ',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'CI',
      name: 'Côte d\'Ivoire',
      type: 'country',
      twoDigitCode: 'CI',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'CD',
      name: 'Democratic Republic of the Congo',
      type: 'country',
      twoDigitCode: 'CD',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'DK',
      name: 'Denmark',
      type: 'country',
      twoDigitCode: 'DK',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'DJ',
      name: 'Djibouti',
      type: 'country',
      twoDigitCode: 'DJ',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'DM',
      name: 'Dominica',
      type: 'country',
      twoDigitCode: 'DM',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'DO',
      name: 'Dominican Republic',
      type: 'country',
      twoDigitCode: 'DO',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'EC',
      name: 'Ecuador',
      type: 'country',
      twoDigitCode: 'EC',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'EG',
      name: 'Egypt',
      type: 'country',
      twoDigitCode: 'EG',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'SV',
      name: 'El Salvador',
      type: 'country',
      twoDigitCode: 'SV',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'GQ',
      name: 'Equatorial Guinea',
      type: 'country',
      twoDigitCode: 'GQ',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'ER',
      name: 'Eritrea',
      type: 'country',
      twoDigitCode: 'ER',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'EE',
      name: 'Estonia',
      type: 'country',
      twoDigitCode: 'EE',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'ET',
      name: 'Ethiopia',
      type: 'country',
      twoDigitCode: 'ET',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'FK',
      name: 'Falkland Islands',
      type: 'country',
      twoDigitCode: 'FK',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'FO',
      name: 'Faroe Islands',
      type: 'country',
      twoDigitCode: 'FO',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'FM',
      name: 'Federated States of Micronesia',
      type: 'country',
      twoDigitCode: 'FM',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'FJ',
      name: 'Fiji',
      type: 'country',
      twoDigitCode: 'FJ',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'FI',
      name: 'Finland',
      type: 'country',
      twoDigitCode: 'FI',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'FR',
      name: 'France',
      type: 'country',
      twoDigitCode: 'FR',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'GF',
      name: 'French Guiana',
      type: 'country',
      twoDigitCode: 'GF',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'PF',
      name: 'French Polynesia',
      type: 'country',
      twoDigitCode: 'PF',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'TF',
      name: 'French Southern Territories',
      type: 'country',
      twoDigitCode: 'TF',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'GA',
      name: 'Gabon',
      type: 'country',
      twoDigitCode: 'GA',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'GE',
      name: 'Georgia',
      type: 'country',
      twoDigitCode: 'GE',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'DE',
      name: 'Germany',
      type: 'country',
      twoDigitCode: 'DE',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'GH',
      name: 'Ghana',
      type: 'country',
      twoDigitCode: 'GH',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'GI',
      name: 'Gibraltar',
      type: 'country',
      twoDigitCode: 'GI',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'GR',
      name: 'Greece',
      type: 'country',
      twoDigitCode: 'GR',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'GL',
      name: 'Greenland',
      type: 'country',
      twoDigitCode: 'GL',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'GD',
      name: 'Grenada',
      type: 'country',
      twoDigitCode: 'GD',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'GP',
      name: 'Guadeloupe',
      type: 'country',
      twoDigitCode: 'GP',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'GU',
      name: 'Guam',
      type: 'country',
      twoDigitCode: 'GU',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'GT',
      name: 'Guatemala',
      type: 'country',
      twoDigitCode: 'GT',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'GG',
      name: 'Guernsey',
      type: 'country',
      twoDigitCode: 'GG',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'GN',
      name: 'Guinea',
      type: 'country',
      twoDigitCode: 'GN',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'GW',
      name: 'Guinea-Bissau',
      type: 'country',
      twoDigitCode: 'GW',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'GY',
      name: 'Guyana',
      type: 'country',
      twoDigitCode: 'GY',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'HT',
      name: 'Haiti',
      type: 'country',
      twoDigitCode: 'HT',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'HM',
      name: 'Heard Island and McDonald Islands',
      type: 'country',
      twoDigitCode: 'HM',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'HN',
      name: 'Honduras',
      type: 'country',
      twoDigitCode: 'HN',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'HK',
      name: 'Hong Kong',
      type: 'country',
      twoDigitCode: 'HK',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'HU',
      name: 'Hungary',
      type: 'country',
      twoDigitCode: 'HU',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'IS',
      name: 'Iceland',
      type: 'country',
      twoDigitCode: 'IS',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'IN',
      name: 'India',
      type: 'country',
      twoDigitCode: 'IN',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'ID',
      name: 'Indonesia',
      type: 'country',
      twoDigitCode: 'ID',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'IQ',
      name: 'Iraq',
      type: 'country',
      twoDigitCode: 'IQ',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'IE',
      name: 'Ireland',
      type: 'country',
      twoDigitCode: 'IE',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'IM',
      name: 'Isle Of Man',
      type: 'country',
      twoDigitCode: 'IM',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'IL',
      name: 'Israel',
      type: 'country',
      twoDigitCode: 'IL',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'IT',
      name: 'Italy',
      type: 'country',
      twoDigitCode: 'IT',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'JM',
      name: 'Jamaica',
      type: 'country',
      twoDigitCode: 'JM',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'JP',
      name: 'Japan',
      type: 'country',
      twoDigitCode: 'JP',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'JE',
      name: 'Jersey',
      type: 'country',
      twoDigitCode: 'JE',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'JO',
      name: 'Jordan',
      type: 'country',
      twoDigitCode: 'JO',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'KZ',
      name: 'Kazakhstan',
      type: 'country',
      twoDigitCode: 'KZ',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'KE',
      name: 'Kenya',
      type: 'country',
      twoDigitCode: 'KE',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'KI',
      name: 'Kiribati',
      type: 'country',
      twoDigitCode: 'KI',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'XK',
      name: 'Kosovo',
      type: 'country',
      twoDigitCode: 'XK',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'KW',
      name: 'Kuwait',
      type: 'country',
      twoDigitCode: 'KW',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'KG',
      name: 'Kyrgyzstan',
      type: 'country',
      twoDigitCode: 'KG',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'LA',
      name: 'Laos',
      type: 'country',
      twoDigitCode: 'LA',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'LV',
      name: 'Latvia',
      type: 'country',
      twoDigitCode: 'LV',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'LB',
      name: 'Lebanon',
      type: 'country',
      twoDigitCode: 'LB',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'LS',
      name: 'Lesotho',
      type: 'country',
      twoDigitCode: 'LS',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'LR',
      name: 'Liberia',
      type: 'country',
      twoDigitCode: 'LR',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'LY',
      name: 'Libya',
      type: 'country',
      twoDigitCode: 'LY',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'LI',
      name: 'Liechtenstein',
      type: 'country',
      twoDigitCode: 'LI',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'LT',
      name: 'Lithuania',
      type: 'country',
      twoDigitCode: 'LT',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'LU',
      name: 'Luxembourg',
      type: 'country',
      twoDigitCode: 'LU',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'MO',
      name: 'Macau',
      type: 'country',
      twoDigitCode: 'MO',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'MK',
      name: 'Macedonia',
      type: 'country',
      twoDigitCode: 'MK',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'MG',
      name: 'Madagascar',
      type: 'country',
      twoDigitCode: 'MG',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'MW',
      name: 'Malawi',
      type: 'country',
      twoDigitCode: 'MW',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'MY',
      name: 'Malaysia',
      type: 'country',
      twoDigitCode: 'MY',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'MV',
      name: 'Maldives',
      type: 'country',
      twoDigitCode: 'MV',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'ML',
      name: 'Mali',
      type: 'country',
      twoDigitCode: 'ML',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'MT',
      name: 'Malta',
      type: 'country',
      twoDigitCode: 'MT',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'MH',
      name: 'Marshall Islands',
      type: 'country',
      twoDigitCode: 'MH',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'MQ',
      name: 'Martinique',
      type: 'country',
      twoDigitCode: 'MQ',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'MR',
      name: 'Mauritania',
      type: 'country',
      twoDigitCode: 'MR',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'MU',
      name: 'Mauritius',
      type: 'country',
      twoDigitCode: 'MU',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'YT',
      name: 'Mayotte',
      type: 'country',
      twoDigitCode: 'YT',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'MX',
      name: 'Mexico',
      type: 'country',
      twoDigitCode: 'MX',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'MD',
      name: 'Moldova',
      type: 'country',
      twoDigitCode: 'MD',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'MC',
      name: 'Monaco',
      type: 'country',
      twoDigitCode: 'MC',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'MN',
      name: 'Mongolia',
      type: 'country',
      twoDigitCode: 'MN',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'ME',
      name: 'Montenegro',
      type: 'country',
      twoDigitCode: 'ME',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'MS',
      name: 'Montserrat',
      type: 'country',
      twoDigitCode: 'MS',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'MA',
      name: 'Morocco',
      type: 'country',
      twoDigitCode: 'MA',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'MZ',
      name: 'Mozambique',
      type: 'country',
      twoDigitCode: 'MZ',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'MM',
      name: 'Myanmar',
      type: 'country',
      twoDigitCode: 'MM',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'NA',
      name: 'Namibia',
      type: 'country',
      twoDigitCode: 'NA',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'NR',
      name: 'Nauru',
      type: 'country',
      twoDigitCode: 'NR',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'NP',
      name: 'Nepal',
      type: 'country',
      twoDigitCode: 'NP',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'NL',
      name: 'Netherlands',
      type: 'country',
      twoDigitCode: 'NL',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'AN',
      name: 'Netherlands Antilles',
      type: 'country',
      twoDigitCode: 'AN',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'NC',
      name: 'New Caledonia',
      type: 'country',
      twoDigitCode: 'NC',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'NZ',
      name: 'New Zealand',
      type: 'country',
      twoDigitCode: 'NZ',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'NI',
      name: 'Nicaragua',
      type: 'country',
      twoDigitCode: 'NI',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'NE',
      name: 'Niger',
      type: 'country',
      twoDigitCode: 'NE',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'NG',
      name: 'Nigeria',
      type: 'country',
      twoDigitCode: 'NG',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'NU',
      name: 'Niue',
      type: 'country',
      twoDigitCode: 'NU',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'NF',
      name: 'Norfolk Island',
      type: 'country',
      twoDigitCode: 'NF',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'MP',
      name: 'Northern Mariana Islands',
      type: 'country',
      twoDigitCode: 'MP',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'NO',
      name: 'Norway',
      type: 'country',
      twoDigitCode: 'NO',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'OM',
      name: 'Oman',
      type: 'country',
      twoDigitCode: 'OM',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'PK',
      name: 'Pakistan',
      type: 'country',
      twoDigitCode: 'PK',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'PW',
      name: 'Palau',
      type: 'country',
      twoDigitCode: 'PW',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'PS',
      name: 'Palestine',
      type: 'country',
      twoDigitCode: 'PS',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'PA',
      name: 'Panama',
      type: 'country',
      twoDigitCode: 'PA',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'PG',
      name: 'Papua New Guinea',
      type: 'country',
      twoDigitCode: 'PG',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'PY',
      name: 'Paraguay',
      type: 'country',
      twoDigitCode: 'PY',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'PE',
      name: 'Peru',
      type: 'country',
      twoDigitCode: 'PE',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'PH',
      name: 'Philippines',
      type: 'country',
      twoDigitCode: 'PH',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'PN',
      name: 'Pitcairn',
      type: 'country',
      twoDigitCode: 'PN',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'PL',
      name: 'Poland',
      type: 'country',
      twoDigitCode: 'PL',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'PT',
      name: 'Portugal',
      type: 'country',
      twoDigitCode: 'PT',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'PR',
      name: 'Puerto Rico',
      type: 'country',
      twoDigitCode: 'PR',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'QA',
      name: 'Qatar',
      type: 'country',
      twoDigitCode: 'QA',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'CG',
      name: 'Republic of the Congo',
      type: 'country',
      twoDigitCode: 'CG',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'RO',
      name: 'Romania',
      type: 'country',
      twoDigitCode: 'RO',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'RU',
      name: 'Russia',
      type: 'country',
      twoDigitCode: 'RU',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'RW',
      name: 'Rwanda',
      type: 'country',
      twoDigitCode: 'RW',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'RE',
      name: 'Réunion',
      type: 'country',
      twoDigitCode: 'RE',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'BL',
      name: 'Saint Barthélemy',
      type: 'country',
      twoDigitCode: 'BL',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'SH',
      name: 'Saint Helena',
      type: 'country',
      twoDigitCode: 'SH',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'KN',
      name: 'Saint Kitts and Nevis',
      type: 'country',
      twoDigitCode: 'KN',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'MF',
      name: 'Saint Martin',
      type: 'country',
      twoDigitCode: 'MF',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'PM',
      name: 'Saint Pierre and Miquelon',
      type: 'country',
      twoDigitCode: 'PM',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'VC',
      name: 'Saint Vincent and the Grenadines',
      type: 'country',
      twoDigitCode: 'VC',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'WS',
      name: 'Samoa',
      type: 'country',
      twoDigitCode: 'WS',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'SM',
      name: 'San Marino',
      type: 'country',
      twoDigitCode: 'SM',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'ST',
      name: 'Sao Tome and Principe',
      type: 'country',
      twoDigitCode: 'ST',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'SA',
      name: 'Saudi Arabia',
      type: 'country',
      twoDigitCode: 'SA',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'SN',
      name: 'Senegal',
      type: 'country',
      twoDigitCode: 'SN',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'RS',
      name: 'Serbia',
      type: 'country',
      twoDigitCode: 'RS',
      supportsRegion: false,
      supportsCity: true,
    },
    {
      key: 'SC',
      name: 'Seychelles',
      type: 'country',
      twoDigitCode: 'SC',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'SL',
      name: 'Sierra Leone',
      type: 'country',
      twoDigitCode: 'SL',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'SG',
      name: 'Singapore',
      type: 'country',
      twoDigitCode: 'SG',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'SX',
      name: 'Sint Maarten',
      type: 'country',
      twoDigitCode: 'SX',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'SK',
      name: 'Slovakia',
      type: 'country',
      twoDigitCode: 'SK',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'SI',
      name: 'Slovenia',
      type: 'country',
      twoDigitCode: 'SI',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'SB',
      name: 'Solomon Islands',
      type: 'country',
      twoDigitCode: 'SB',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'SO',
      name: 'Somalia',
      type: 'country',
      twoDigitCode: 'SO',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'ZA',
      name: 'South Africa',
      type: 'country',
      twoDigitCode: 'ZA',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'GS',
      name: 'South Georgia and the South Sandwich Islands',
      type: 'country',
      twoDigitCode: 'GS',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'KR',
      name: 'South Korea',
      type: 'country',
      twoDigitCode: 'KR',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'SS',
      name: 'South Sudan',
      type: 'country',
      twoDigitCode: 'SS',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'ES',
      name: 'Spain',
      type: 'country',
      twoDigitCode: 'ES',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'LK',
      name: 'Sri Lanka',
      type: 'country',
      twoDigitCode: 'LK',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'LC',
      name: 'St. Lucia',
      type: 'country',
      twoDigitCode: 'LC',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'SR',
      name: 'Suriname',
      type: 'country',
      twoDigitCode: 'SR',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'SJ',
      name: 'Svalbard and Jan Mayen',
      type: 'country',
      twoDigitCode: 'SJ',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'SZ',
      name: 'Swaziland',
      type: 'country',
      twoDigitCode: 'SZ',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'SE',
      name: 'Sweden',
      type: 'country',
      twoDigitCode: 'SE',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'CH',
      name: 'Switzerland',
      type: 'country',
      twoDigitCode: 'CH',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'TW',
      name: 'Taiwan',
      type: 'country',
      twoDigitCode: 'TW',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'TJ',
      name: 'Tajikistan',
      type: 'country',
      twoDigitCode: 'TJ',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'TZ',
      name: 'Tanzania',
      type: 'country',
      twoDigitCode: 'TZ',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'TH',
      name: 'Thailand',
      type: 'country',
      twoDigitCode: 'TH',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'BS',
      name: 'The Bahamas',
      type: 'country',
      twoDigitCode: 'BS',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'GM',
      name: 'The Gambia',
      type: 'country',
      twoDigitCode: 'GM',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'TL',
      name: 'Timor-Leste',
      type: 'country',
      twoDigitCode: 'TL',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'TG',
      name: 'Togo',
      type: 'country',
      twoDigitCode: 'TG',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'TK',
      name: 'Tokelau',
      type: 'country',
      twoDigitCode: 'TK',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'TO',
      name: 'Tonga',
      type: 'country',
      twoDigitCode: 'TO',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'TT',
      name: 'Trinidad and Tobago',
      type: 'country',
      twoDigitCode: 'TT',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'TN',
      name: 'Tunisia',
      type: 'country',
      twoDigitCode: 'TN',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'TR',
      name: 'Turkey',
      type: 'country',
      twoDigitCode: 'TR',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'TM',
      name: 'Turkmenistan',
      type: 'country',
      twoDigitCode: 'TM',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'TC',
      name: 'Turks and Caicos Islands',
      type: 'country',
      twoDigitCode: 'TC',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'TV',
      name: 'Tuvalu',
      type: 'country',
      twoDigitCode: 'TV',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'UG',
      name: 'Uganda',
      type: 'country',
      twoDigitCode: 'UG',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'UA',
      name: 'Ukraine',
      type: 'country',
      twoDigitCode: 'UA',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'AE',
      name: 'United Arab Emirates',
      type: 'country',
      twoDigitCode: 'AE',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'GB',
      name: 'United Kingdom',
      type: 'country',
      twoDigitCode: 'GB',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'US',
      name: 'United States',
      type: 'country',
      twoDigitCode: 'US',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'UM',
      name: 'United States Minor Outlying Islands',
      type: 'country',
      twoDigitCode: 'UM',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'UY',
      name: 'Uruguay',
      type: 'country',
      twoDigitCode: 'UY',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'VI',
      name: 'US Virgin Islands',
      type: 'country',
      twoDigitCode: 'VI',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'UZ',
      name: 'Uzbekistan',
      type: 'country',
      twoDigitCode: 'UZ',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'VU',
      name: 'Vanuatu',
      type: 'country',
      twoDigitCode: 'VU',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'VA',
      name: 'Vatican City',
      type: 'country',
      twoDigitCode: 'VA',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'VE',
      name: 'Venezuela',
      type: 'country',
      twoDigitCode: 'VE',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'VN',
      name: 'Vietnam',
      type: 'country',
      twoDigitCode: 'VN',
      supportsRegion: true,
      supportsCity: true,
    },
    {
      key: 'WF',
      name: 'Wallis and Futuna',
      type: 'country',
      twoDigitCode: 'WF',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'EH',
      name: 'Western Sahara',
      type: 'country',
      twoDigitCode: 'EH',
      supportsRegion: false,
      supportsCity: false,
    },
    {
      key: 'YE',
      name: 'Yemen',
      type: 'country',
      twoDigitCode: 'YE',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'ZM',
      name: 'Zambia',
      type: 'country',
      twoDigitCode: 'ZM',
      supportsRegion: true,
      supportsCity: false,
    },
    {
      key: 'ZW',
      name: 'Zimbabwe',
      type: 'country',
      twoDigitCode: 'ZW',
      supportsRegion: true,
      supportsCity: false,
    },
  ];

  const facebookAdCountriesByName = {};
  const facebookAdCountriesByISO2 = {};

  facebookAdCountries.forEach((country) => {
    facebookAdCountriesByName[country.name] = country;
    facebookAdCountriesByISO2[country.twoDigitCode] = country;
  });

  curalate.constant('FacebookAdCountries', facebookAdCountries);
  curalate.constant('FacebookAdCountriesByName', facebookAdCountriesByName);
  curalate.constant('FacebookAdCountriesByISO2', facebookAdCountriesByISO2);
})();
